import type { ArtccId } from "@poscon/shared-types";
import type { ControllerSectorId, PosconRole } from "@poscon/shared-types/poscon";
import { RootStore } from "./store";
import { SquelchXmtrPayload } from "~/commands";
import { updateSquelch } from "./slices/vscsSlice";
import { listen } from "@tauri-apps/api/event";
import { vscsHubConnection, injectStore } from "~/vscsHubConnection";

const urlParams = new URLSearchParams(window.location.search);

export function afterStoreInit(store: RootStore) {
    injectStore(store);

    const artccId = (urlParams.get("artccId") ?? urlParams.get("sectorId")?.split(".")[0]) as ArtccId | undefined;
    const sectorId = (urlParams.get("sectorId") ?? null) as ControllerSectorId | null;
    const role = (urlParams.get("role") ?? "Radar") as PosconRole;

    if (artccId) {
        void vscsHubConnection
            .initialize(artccId, sectorId, role)
            .then(() => vscsHubConnection.connect());
    }

    if (window.__TAURI__) {
        listen<SquelchXmtrPayload>("squelch", ({ payload }) => {
            store.dispatch(updateSquelch({ id: payload.btnId, value: { rx: payload.rx, tx: payload.tx } }));
        });
    }
}
